import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { AlertService } from 'src/app/shared/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ModalController } from '@ionic/angular';
import { CardNumberModalComponent } from 'src/app/account/forms/card-number-modal/card-number-modal.component';
import { TranslationService } from 'src/app/shared/services/translation.service';

export interface IRegisterForm {
  email: string;
  codeId: number;
  codeExpirationTime: string;
  memberCard?: string;
  cvc?: number;
}

@Component({
    selector: 'auth-register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss'],
    standalone: false
})
export class RegisterFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  @Input() fromDesktopCheckout: boolean = false;
  @Output()
  onSubmit: EventEmitter<IRegisterForm> = new EventEmitter<IRegisterForm>();
  alreadyInUse: boolean = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private loader: LoaderService,
    private router: Router,
    //private translateService: TranslateService,
    public validators: ValidatorsService,
    public settingService: SettingService,
    private modalCtrl: ModalController,
    private translationService: TranslationService
  ) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'email' : ['', this.validators.formBuilderValidationInitializer(true, null, true)],
    });
    */
    this.form = this.fb.group({
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      email: null,
    };
    */
    this.patternReference = {
      email: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  async submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    this.alreadyInUse = false;

    if (!this.form.valid)
      return;

    this.formErrors.clear();

    // put the logic for the member card here before we send the code
    if(this.settingService.configuration.memberCardMandatory) {
      this.OpenMemberCardModal();

    } else {

      const loader = await this.loader.create();
      await loader.present();
      this.auth.emailCodeVerificationStart(this.form.get("email").value, "Register", this.translationService.getLanguage())
        .pipe(finalize(() => {
          loader.dismiss();
        }))
        .subscribe(result => {
          this.onSubmit.emit({
            email: this.form.get("email").value,
            codeId: result.EmailCodeId,
            codeExpirationTime: result.ExpirationTime,
          });
        },
        (error: HttpErrorResponse) => {
          if (error.error.Message == 'AlreadyExist')
            this.alreadyInUse = true;
        });
    }


    
  }

  goToLogin() {
    this.router.navigateByUrl('/auth/login');
  }


  async OpenMemberCardModal() {
    // prevents crash if the undocked navbar is inside a popup
    const modal = await this.modalCtrl.create({
      component: CardNumberModalComponent,
      cssClass: '',
      componentProps: {
        disableHeader: true
      }
    });
  
    modal.onWillDismiss()
      .then(async (modalResult) => {

        if(modalResult.data != null) {
          const loader = await this.loader.create();
          await loader.present();
          this.auth.emailCodeVerificationStart(this.form.get("email").value, "Register", this.translationService.getLanguage())
            .pipe(finalize(() => {
              loader.dismiss();
            }))
            .subscribe(result => {
              this.onSubmit.emit({
                email: this.form.get("email").value,
                codeId: result.EmailCodeId,
                codeExpirationTime: result.ExpirationTime,
                memberCard: modalResult.data
              });
            },
            (error: HttpErrorResponse) => {
              if (error.error.Message == 'AlreadyExist')
                this.alreadyInUse = true;
            });
        }
        
    });
  
    await modal.present();
  }
}
